module.exports = __webpack_public_path__ + "static/media/logomarcaoflix.7da50b3c.png";